// extracted by mini-css-extract-plugin
module.exports = {"chartControls":"-chart-controls-chartControls-26CmVa-","rightSection":"-chart-controls-rightSection-3HtlJL-","toggle":"-chart-controls-toggle-4YCkDG-"};